module.exports = __webpack_public_path__ + "static/media/csarnokepulet-alapozas-tahi.5cac100a.jpg";